import React, { useEffect } from "react";
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Select,
  DatePicker,
  Spin,
  InputNumber,
  Divider,
  Space,
  Button,
  Tooltip,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import dayjs from "dayjs";
const { Text, Title } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    currencyData,
    // allowWithdrawal,
    // adjustAdvanceTowardsFuturePayments,
    // isMandatoryDeposit,
    // isCalendarInherited,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
    periodFrequencyTypeOptions,
    lockinPeriodFrequencyTypeOptions,
  } = props;
  const isCalendarInherited = Form.useWatch("isCalendarInherited", form);
  const dateFormat = "DD-MM-YYYY";

  useEffect(() => {
    defaultDate();
  }, []);

  const defaultDate = () => {
    form.setFieldsValue({
      submittedOnDate: dayjs(),
    });
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.interestInformation}
          </Title>
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCompoundingPeriod}
            name={"interestCompoundingPeriodType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCompoundingPeriod,
                "select"
              )}
              options={interestCompoundingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestPostingPeriod}
            name={"interestPostingPeriodType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestPostingPeriod,
                "select"
              )}
              options={interestPostingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculatedUsing}
            name={"interestCalculationType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCalculatedUsing,
                "select"
              )}
              options={interestCalculationTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.daysInYear}
            name={"interestCalculationDaysInYearType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.daysInYear),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.daysInYear,
                "select"
              )}
              options={interestCalculationDaysInYearTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockInPeriod}
            name={"lockinPeriodFrequency"}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={" "} name={"lockinPeriodFrequencyType"}>
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.lockInPeriod,
                "select"
              )}
              options={lockinPeriodFrequencyTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.additionalInfo}
          </Title>
        </Divider>
        {/* Deposit Details */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.isMandatoryDeposit}</Text>}
            name={"isMandatoryDeposit"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder="Select one"
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.allowWithdrawals}</Text>}
            name={"allowWithdrawal"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder="Select one"
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.adjustAdvancePayments}>
                {BOM.SubstringFormat(labelConfig.adjustAdvancePayments, 20)}
              </Tooltip>
            }
            name={"adjustAdvanceTowardsFuturePayments"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder="Select one"
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.recurringDepositAmount}
            name={"mandatoryRecommendedDepositAmount"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.recurringDepositAmount),
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.recurringDepositAmount
              )}
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.depositPeriod}
            name={"depositPeriod"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.depositPeriod),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.depositPeriod)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.depositPeriodType}
            name={"depositPeriodFrequencyId"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.depositPeriodFrequency),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.depositPeriodType,
                "select"
              )}
              options={periodFrequencyTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.depositFrequencySameAsGroup}>
                {BOM.SubstringFormat(
                  labelConfig.depositFrequencySameAsGroup,
                  20
                )}
              </Tooltip>
            }
            name={"isCalendarInherited"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder="Select one"
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>

        {!isCalendarInherited && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.depositStartDate}
                name={"expectedFirstDepositOnDate"}
                // rules={[
                //   {
                //     required: true,
                //     message: BOM.CheckReqFld(labelConfig.depositStartDate),
                //   },
                // ]}
              >
                <DatePicker
                  disabledDate={BOM.DisabledAfterCurrentDate}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.depositStartDate,
                    "select"
                  )}
                  style={{ width: "100%", height: 35 }}
                  format={dateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.depositFrequency}
                name={"recurringFrequency"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.depositPeriod),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.depositPeriod
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.depositFrequencyType}
                name={"recurringFrequencyType"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(
                      labelConfig.depositPeriodFrequency
                    ),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.depositPeriod,
                    "select"
                  )}
                  options={periodFrequencyTypeOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};

export default TermsForm;
